
export enum TriggeredBy {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL'
}